/**
 * @generated SignedSource<<cc1fb98bbc1416face48a8ad074cc3d5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PersonSidePanel_sourcePerson$data = {
  readonly " $fragmentSpreads": FragmentRefs<"MatchDetailTab_person">;
  readonly " $fragmentType": "PersonSidePanel_sourcePerson";
};
export type PersonSidePanel_sourcePerson$key = {
  readonly " $data"?: PersonSidePanel_sourcePerson$data;
  readonly " $fragmentSpreads": FragmentRefs<"PersonSidePanel_sourcePerson">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PersonSidePanel_sourcePerson",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MatchDetailTab_person"
    }
  ],
  "type": "people",
  "abstractKey": null
};

(node as any).hash = "4ddf558202b61860f11d8ca6a641466f";

export default node;
